import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/darkmode/DarkModeBtn.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Providers"] */ "/vercel/path0/components/darkmode/Providers.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next-view-transitions@0.3.2_mkzy2mk6yj6i6q3p5zljovfyiu/node_modules/next-view-transitions/dist/index.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/styles/globals.css");
